// src/services/api.js
import axios from "axios";

// Se preferisci, puoi mettere la base URL in un file .env (REACT_APP_API_BASE_URL)
const BASE_URL = process.env.REACT_APP_API_URL ;

// Crea l'istanza di axios con la baseURL
const api = axios.create({
  baseURL: BASE_URL,
});

// Interceptor per aggiungere il token Bearer, se presente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token"); 
  // Assumiamo che dopo il login tu salvi il token in localStorage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
